import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/store';
import {
  showAlertError,
  hideAlertError,
  selectAssessmentAlertError,
} from '../assessmentsAuthSlice';
import { UseAssessmentsAlertErrorReturn } from '../types';

export const useAssessmentsAlertError = (): UseAssessmentsAlertErrorReturn => {
  const dispatch = useAppDispatch();
  const { isShowingAlertError, alertError } = useSelector(selectAssessmentAlertError);
  const handleAlertDismiss = useCallback(() => {
    dispatch(hideAlertError());
  }, [dispatch]);

  const showAlert = useCallback(
    (message: string, position: 'top' | 'bottom' = 'top') => {
      dispatch(
        showAlertError({
          message,
          position,
          handleDismiss: handleAlertDismiss,
        }),
      );
    },
    [dispatch, handleAlertDismiss],
  );

  const hideAlert = useCallback(() => {
    dispatch(hideAlertError());
  }, [dispatch]);

  return {
    isShowingAlertError,
    alertError: {
      message: alertError.message,
      position: alertError.position,
      handleDismiss: handleAlertDismiss,
    },
    showAlert,
    hideAlert,
    handleAlertDismiss,
  };
};
